import { useState } from "react";
import { Tooltip } from "ui/popovers/Tooltip";
import ToggleGroup from "./ToggleGroup";

<Tooltip.Provider>
<div style={{ maxWidth: "600px" }}>
## Single Selection

export function SingleSelection() {
const [alignment, setAlignment] = useState("center");
return (

<div>
  <ToggleGroup.Root type="single" value={alignment} onValueChange={setAlignment}>
    <ToggleGroup.Item value="left">Left</ToggleGroup.Item>
    <ToggleGroup.Item value="center">Center</ToggleGroup.Item>
    <ToggleGroup.Item value="right">Right</ToggleGroup.Item>
  </ToggleGroup.Root>
  <p>Selected: **{alignment || "none"}**</p>
</div>
); }

<SingleSelection />

---

## Multiple Selection

export function MultipleSelection() {
const [formatting, setFormatting] = useState(["bold"]);
return (

<div>
  <ToggleGroup.Root type="multiple" value={formatting} onValueChange={setFormatting}>
    <ToggleGroup.Item value="bold">
      <strong>B</strong>
    </ToggleGroup.Item>
    <ToggleGroup.Item value="italic">
      <em>I</em>
    </ToggleGroup.Item>
    <ToggleGroup.Item value="underline">
      <u>U</u>
    </ToggleGroup.Item>
  </ToggleGroup.Root>
  <p>Selected: **{formatting.join(", ") || "none"}**</p>
</div>
); }

<MultipleSelection />

---

## Styles

#### Primary
export function PrimaryStyle() {
const [selection, setSelection] = useState("option1");
return (

<div>
  <ToggleGroup.Root value={selection} onValueChange={setSelection} type="single" toggleStyle="primary">
    <ToggleGroup.Item value="option1">Option 1</ToggleGroup.Item>
    <ToggleGroup.Item value="option2">Option 2</ToggleGroup.Item>
  </ToggleGroup.Root>
</div>
); }

<PrimaryStyle />

#### Secondary
export function SecondaryStyle() {
const [selection, setSelection] = useState("option1");
return (

<div>
  <ToggleGroup.Root value={selection} onValueChange={setSelection} type="single" toggleStyle="secondary">
    <ToggleGroup.Item value="option1">Option 1</ToggleGroup.Item>
    <ToggleGroup.Item value="option2">Option 2</ToggleGroup.Item>
  </ToggleGroup.Root>
</div>
); }

<SecondaryStyle />

#### Tertiary
export function TertiaryStyle() {
const [selection, setSelection] = useState("option1");
return (

<div>
  <ToggleGroup.Root value={selection} onValueChange={setSelection} type="single" toggleStyle="tertiary">
    <ToggleGroup.Item value="option1">Option 1</ToggleGroup.Item>
    <ToggleGroup.Item value="option2">Option 2</ToggleGroup.Item>
  </ToggleGroup.Root>
</div>
); }

<TertiaryStyle />

---

## Vertical Layout

export function VerticalLayout() {
const [selection, setSelection] = useState("option2");
return (

<ToggleGroup.Root type="single" value={selection} onValueChange={setSelection} orientation="vertical">
  <ToggleGroup.Item value="option1">Option 1</ToggleGroup.Item>
  <ToggleGroup.Item value="option2">Option 2</ToggleGroup.Item>
  <ToggleGroup.Item value="option3">Option 3</ToggleGroup.Item>
</ToggleGroup.Root>
); }

<VerticalLayout />

---

## Always Has Value

Using `allowEmpty={false}` prevents deselecting all options.

export function AlwaysHasValue() {
const [value, setValue] = useState("medium");
return (

<div>
  <ToggleGroup.Root type="single" value={value} onValueChange={setValue} allowEmpty={false}>
    <ToggleGroup.Item value="small">Small</ToggleGroup.Item>
    <ToggleGroup.Item value="medium">Medium</ToggleGroup.Item>
    <ToggleGroup.Item value="large">Large</ToggleGroup.Item>
  </ToggleGroup.Root>
  <p>Try clicking the selected option—it stays selected.</p>
</div>
); }

<AlwaysHasValue />

---

## Disabled

<ToggleGroup.Root type="single" disabled defaultValue="option1">
  <ToggleGroup.Item value="option1">Option 1</ToggleGroup.Item>
  <ToggleGroup.Item value="option2">Option 2</ToggleGroup.Item>
  <ToggleGroup.Item value="option3">Option 3</ToggleGroup.Item>
</ToggleGroup.Root>

---

## With Tooltips

<ToggleGroup.Root type="single" defaultValue="center">
  <ToggleGroup.Item value="left" tooltip="Align left">
    Left
  </ToggleGroup.Item>
  <ToggleGroup.Item value="center" tooltip="Align center">
    Center
  </ToggleGroup.Item>
  <ToggleGroup.Item value="right" tooltip="Align right">
    Right
  </ToggleGroup.Item>
</ToggleGroup.Root>

</div>
</Tooltip.Provider>
